import spaLoad from './js/spa-load';

export {
    spaLoad,
};
